import React from "react";
import "./HeroSection.css";

interface LeftHeroProps {
  title: string;
  subtitle: string;
  highlight?: string;
  primaryBtn?: { label: string; onClick?: () => void; link?: string };
  secondaryBtn?: { label: string; onClick?: () => void; link?: string };
}

const LeftHero: React.FC<LeftHeroProps> = ({
  title,
  subtitle,
  highlight,
  primaryBtn,
  secondaryBtn,
}) => {
  return (
    <div className="hero-content">
      <h1
        className="hero-title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p className="hero-subtitle">
        {highlight && <span className="brand">{highlight}</span>}{" "}
        <span dangerouslySetInnerHTML={{ __html: subtitle }} />
      </p>

      <div className="hero-buttons">
        {primaryBtn && (
          <a
            href={primaryBtn.link || "#"}
            onClick={primaryBtn.onClick}
            className="btn-primary"
          >
            {primaryBtn.label}
          </a>
        )}
        {secondaryBtn && (
          <a
            href={secondaryBtn.link || "#"}
            onClick={secondaryBtn.onClick}
            className="btn-outline"
          >
            {secondaryBtn.label}
          </a>
        )}
      </div>
    </div>
  );
};

export default LeftHero;
